/**
 * Rechnungen mock data (Story UI-U4 — full peek explorable in VITE_DATA_MODE=mock).
 * FRONTEND-ONLY fallback (mock layer NOT deleted). Covers all four K-categories,
 * an unmatched row, a low-confidence matched row, and two final_settlement rows.
 */
import type { InvoiceCheckDetailDto } from '@brokly/shared';
import type { InvoiceHistoryResult } from '../../lib/api-client';
import type { InvoiceRow } from './types';

const SUBJ = 'firma';

export const INVOICES_MOCK: InvoiceRow[] = [
  {
    id: 'RE-2026-04812',
    nr: 'RE-2026-04812',
    kunde: 'Bergland Logistik AG',
    versicherer: 'AXA',
    police: 'POL-883-4471',
    policyId: 'pol-4471',
    subjectId: 'f-berg',
    subjectType: SUBJ,
    typ: 'recurring',
    erwartet: 48200,
    rechnung: 61840,
    differenz: 13640,
    pct: 28.3,
    kategorie: 'K3',
    pflichtregel: true,
    rawStatus: 'blocked',
    wartezeitTage: 21,
    createdAt: '2026-07-07T08:00:00.000Z',
  },
  {
    id: 'RE-2026-04720',
    nr: 'RE-2026-04720',
    kunde: 'Genève Maritime SA',
    versicherer: 'Swiss Life',
    police: 'POL-118-7740',
    policyId: 'pol-7740',
    subjectId: 'f-gen',
    subjectType: SUBJ,
    typ: 'final_settlement',
    erwartet: 27800,
    rechnung: 34950,
    differenz: 7150,
    pct: 25.7,
    kategorie: 'K3',
    rawStatus: 'blocked',
    wartezeitTage: 18,
    createdAt: '2026-07-10T08:00:00.000Z',
  },
  {
    id: 'RE-2026-04640',
    nr: 'RE-2026-04640',
    kunde: 'Alpina Pharma AG',
    versicherer: 'Mobiliar',
    police: 'POL-204-1185',
    policyId: 'pol-1185',
    subjectId: 'f-alp',
    subjectType: SUBJ,
    typ: 'recurring',
    erwartet: 92400,
    rechnung: 96100,
    differenz: 3700,
    pct: 4.0,
    kategorie: 'K2',
    rawStatus: 'in_review',
    wartezeitTage: 14,
    createdAt: '2026-07-14T08:00:00.000Z',
  },
  {
    id: 'RE-2026-04590',
    nr: 'RE-2026-04590',
    kunde: 'Zürcher Präzision AG',
    versicherer: 'Helvetia',
    police: 'POL-551-9023',
    policyId: 'pol-9023',
    subjectId: 'f-zur',
    subjectType: SUBJ,
    typ: 'final_settlement',
    erwartet: 132000,
    rechnung: 140200,
    differenz: 8200,
    pct: 6.2,
    kategorie: 'K2',
    rawStatus: 'in_review',
    wartezeitTage: 12,
    createdAt: '2026-07-16T08:00:00.000Z',
  },
  {
    id: 'RE-2026-04555',
    nr: 'RE-2026-04555',
    kunde: 'Basler Chemie AG',
    versicherer: 'AXA',
    police: 'POL-771-5521',
    policyId: 'pol-5521',
    subjectId: 'f-bas',
    subjectType: SUBJ,
    typ: 'recurring',
    erwartet: 156000,
    rechnung: 159100,
    differenz: 3100,
    pct: 2.0,
    kategorie: 'K1',
    rawStatus: 'checked',
    wartezeitTage: 9,
    createdAt: '2026-07-19T08:00:00.000Z',
  },
  {
    id: 'RE-2026-04512',
    nr: 'RE-2026-04512',
    kunde: 'Luzerner Transport AG',
    versicherer: 'Mobiliar',
    police: 'POL-771-2031',
    policyId: 'pol-2031',
    subjectId: 'f-luz',
    subjectType: SUBJ,
    typ: 'recurring',
    erwartet: 41200,
    rechnung: 41610,
    differenz: 410,
    pct: 1.0,
    kategorie: 'K0',
    rawStatus: 'released',
    wartezeitTage: 4,
    createdAt: '2026-07-24T08:00:00.000Z',
  },
  {
    id: 'RE-2026-04498',
    nr: 'RE-2026-04498',
    kunde: 'Tessin Wein AG',
    versicherer: 'AXA',
    police: 'POL-455-1190',
    policyId: 'pol-1190',
    subjectId: 'f-tes',
    subjectType: SUBJ,
    typ: 'recurring',
    erwartet: 8650,
    rechnung: 8662,
    differenz: 12,
    pct: 0.1,
    kategorie: 'K0',
    rawStatus: 'paid',
    wartezeitTage: 2,
    createdAt: '2026-07-26T08:00:00.000Z',
  },
  {
    id: 'RE-2026-04801',
    nr: 'RE-2026-04801',
    kunde: '-',
    versicherer: 'CSS',
    police: '-',
    policyId: null,
    subjectId: null,
    subjectType: null,
    typ: 'recurring',
    erwartet: 0,
    rechnung: 12400,
    differenz: 12400,
    pct: 0,
    kategorie: null,
    rawStatus: 'received',
    wartezeitTage: 15,
    createdAt: '2026-07-13T08:00:00.000Z',
  },
  {
    id: 'RE-2026-04777',
    nr: 'RE-2026-04777',
    kunde: 'Rheintal Bau GmbH',
    versicherer: 'Helvetia',
    police: 'POL-339-9921',
    policyId: 'pol-9921',
    subjectId: 'f-rhe',
    subjectType: SUBJ,
    typ: 'recurring',
    erwartet: 64500,
    rechnung: 64500,
    differenz: 0,
    pct: 0,
    kategorie: null,
    rawStatus: 'matched',
    wartezeitTage: 13,
    createdAt: '2026-07-15T08:00:00.000Z',
  },
];

const THRESHOLD_SNAPSHOT = {
  mode: 'percent',
  t1: 2,
  t2: 10,
  rounding_tolerance: 0.1,
};

/** Per-invoice check-detail facts for the peek (keyed by row id). */
export const CHECK_DETAIL_MOCK: Record<string, InvoiceCheckDetailDto> = {
  'RE-2026-04812': {
    invoice_id: 'RE-2026-04812',
    match: {
      confidence: '1.00',
      decision_reason: 'matched:stufe1:police+carrier-exakt',
      endorsement_version_id: 'ev-4471-3',
      created_at: '2026-07-07T08:01:00.000Z',
    },
    latest_check: {
      category: 'K3',
      check_status: 'blocked',
      deviation_direction: 'overpayment',
      expected_premium: '48200.00',
      invoiced_premium: '61840.00',
      deviation_absolute: '13640.00',
      deviation_percent: '28.30',
      effective_date: '2026-01-01',
      prorata_applied: false,
      threshold_applied: THRESHOLD_SNAPSHOT,
      decision_reason: 'Pflicht-mismatch: Versicherungsnehmer weicht von der Police ab',
      payment_release: false,
      checked_by: null,
      check_timestamp: '2026-07-07T08:05:00.000Z',
      created_at: '2026-07-07T08:05:00.000Z',
    },
    settlement: null,
  },
  'RE-2026-04720': {
    invoice_id: 'RE-2026-04720',
    match: {
      confidence: '1.00',
      decision_reason: 'matched:stufe1:police+carrier-exakt',
      endorsement_version_id: 'ev-7740-1',
      created_at: '2026-07-10T08:01:00.000Z',
    },
    latest_check: {
      category: 'K3',
      check_status: 'blocked',
      deviation_direction: 'overpayment',
      expected_premium: '27800.00',
      invoiced_premium: '34950.00',
      deviation_absolute: '7150.00',
      deviation_percent: '25.70',
      effective_date: '2026-01-01',
      prorata_applied: false,
      threshold_applied: THRESHOLD_SNAPSHOT,
      decision_reason: 'K3: Abweichung über t2',
      payment_release: false,
      checked_by: null,
      check_timestamp: '2026-07-10T08:05:00.000Z',
      created_at: '2026-07-10T08:05:00.000Z',
    },
    settlement: {
      declared_wage_sum: '4200000.00',
      reported_wage_sum: '3400000.00',
      wage_categories_json: [
        { category_code: 'Verwaltung', rate: 0.4, wage: 1400000, premium: 5600 },
        { category_code: 'Betrieb', rate: 1.05, wage: 2800000, premium: 29400 },
      ],
      rate_per_category_json: { Verwaltung: 0.4, Betrieb: 1.05 },
      provisional_premium: '27800.00',
      final_premium: '34950.00',
      balance_amount: '7150.00',
    },
  },
  'RE-2026-04640': {
    invoice_id: 'RE-2026-04640',
    match: {
      confidence: '1.00',
      decision_reason: 'matched:stufe1:police+carrier-exakt',
      endorsement_version_id: 'ev-1185-2',
      created_at: '2026-07-14T08:01:00.000Z',
    },
    latest_check: {
      category: 'K2',
      check_status: 'in_review',
      deviation_direction: 'overpayment',
      expected_premium: '92400.00',
      invoiced_premium: '96100.00',
      deviation_absolute: '3700.00',
      deviation_percent: '4.00',
      effective_date: '2026-03-01',
      prorata_applied: true,
      threshold_applied: THRESHOLD_SNAPSHOT,
      decision_reason: 'K2: mittlere Abweichung, manuelle Prüfung',
      payment_release: false,
      checked_by: null,
      check_timestamp: '2026-07-14T08:05:00.000Z',
      created_at: '2026-07-14T08:05:00.000Z',
    },
    settlement: null,
  },
  'RE-2026-04590': {
    invoice_id: 'RE-2026-04590',
    match: {
      confidence: '1.00',
      decision_reason: 'matched:stufe1:police+carrier-exakt',
      endorsement_version_id: 'ev-9023-4',
      created_at: '2026-07-16T08:01:00.000Z',
    },
    latest_check: {
      category: 'K2',
      check_status: 'in_review',
      deviation_direction: 'overpayment',
      expected_premium: '132000.00',
      invoiced_premium: '140200.00',
      deviation_absolute: '8200.00',
      deviation_percent: '6.20',
      effective_date: '2026-01-01',
      prorata_applied: false,
      threshold_applied: THRESHOLD_SNAPSHOT,
      decision_reason: 'K2: Lohnsummen-Abweichung, manuelle Prüfung',
      payment_release: false,
      checked_by: null,
      check_timestamp: '2026-07-16T08:05:00.000Z',
      created_at: '2026-07-16T08:05:00.000Z',
    },
    settlement: {
      declared_wage_sum: '11000000.00',
      reported_wage_sum: '10500000.00',
      wage_categories_json: [
        { category_code: 'Büro', rate: 0.6, wage: 4000000, premium: 24000 },
        { category_code: 'Produktion', rate: 1.66, wage: 7000000, premium: 116200 },
      ],
      rate_per_category_json: { Büro: 0.6, Produktion: 1.66 },
      provisional_premium: '132000.00',
      final_premium: '140200.00',
      balance_amount: '8200.00',
    },
  },
  'RE-2026-04555': {
    invoice_id: 'RE-2026-04555',
    match: {
      confidence: '1.00',
      decision_reason: 'matched:stufe1:police+carrier-exakt',
      endorsement_version_id: 'ev-5521-1',
      created_at: '2026-07-19T08:01:00.000Z',
    },
    latest_check: {
      category: 'K1',
      check_status: 'checked',
      deviation_direction: 'overpayment',
      expected_premium: '156000.00',
      invoiced_premium: '159100.00',
      deviation_absolute: '3100.00',
      deviation_percent: '2.00',
      effective_date: '2026-01-01',
      prorata_applied: false,
      threshold_applied: THRESHOLD_SNAPSHOT,
      decision_reason: 'K1: geringfügig, innerhalb Toleranz t1',
      payment_release: false,
      checked_by: null,
      check_timestamp: '2026-07-19T08:05:00.000Z',
      created_at: '2026-07-19T08:05:00.000Z',
    },
    settlement: null,
  },
  'RE-2026-04512': {
    invoice_id: 'RE-2026-04512',
    match: {
      confidence: '1.00',
      decision_reason: 'matched:stufe1:police+carrier-exakt',
      endorsement_version_id: 'ev-2031-1',
      created_at: '2026-07-24T08:01:00.000Z',
    },
    latest_check: {
      category: 'K0',
      check_status: 'released',
      deviation_direction: 'none',
      expected_premium: '41200.00',
      invoiced_premium: '41610.00',
      deviation_absolute: '410.00',
      deviation_percent: '1.00',
      effective_date: '2026-01-01',
      prorata_applied: false,
      threshold_applied: THRESHOLD_SNAPSHOT,
      decision_reason: 'K0: innerhalb Rundungstoleranz',
      payment_release: true,
      checked_by: 'system',
      check_timestamp: '2026-07-24T08:05:00.000Z',
      created_at: '2026-07-24T08:05:00.000Z',
    },
    settlement: null,
  },
  'RE-2026-04777': {
    invoice_id: 'RE-2026-04777',
    match: {
      confidence: '0.40',
      decision_reason: 'matched:stufe3:iban-only',
      endorsement_version_id: null,
      created_at: '2026-07-15T08:01:00.000Z',
    },
    latest_check: null,
    settlement: null,
  },
  'RE-2026-04801': {
    invoice_id: 'RE-2026-04801',
    match: null,
    latest_check: null,
    settlement: null,
  },
};

/** Per-invoice Verlauf activity log (keyed by row id). */
export const HISTORY_MOCK: Record<string, InvoiceHistoryResult> = {
  'RE-2026-04812': {
    invoiceId: 'RE-2026-04812',
    activityLog: [
      {
        id: 'log-4812-1',
        invoiceId: 'RE-2026-04812',
        step: 'match',
        actor: 'system',
        result: 'matched:stufe1',
        appliedVersionId: 'ev-4471-3',
        appliedThreshold: null,
        createdAt: '2026-07-07T08:01:00.000Z',
      },
      {
        id: 'log-4812-2',
        invoiceId: 'RE-2026-04812',
        step: 'categorize',
        actor: 'system',
        result: 'K3',
        appliedThreshold: THRESHOLD_SNAPSHOT,
        appliedVersionId: null,
        createdAt: '2026-07-07T08:05:00.000Z',
      },
      {
        id: 'log-4812-3',
        invoiceId: 'RE-2026-04812',
        step: 'handle',
        actor: 'system',
        result: 'blocked+beanstandung',
        appliedThreshold: null,
        appliedVersionId: null,
        createdAt: '2026-07-07T08:06:00.000Z',
      },
    ],
    latestCategory: 'K3',
    appliedThreshold: THRESHOLD_SNAPSHOT,
    isReproducible: true,
  },
  'RE-2026-04640': {
    invoiceId: 'RE-2026-04640',
    activityLog: [
      {
        id: 'log-4640-1',
        invoiceId: 'RE-2026-04640',
        step: 'match',
        actor: 'system',
        result: 'matched:stufe1',
        appliedVersionId: 'ev-1185-2',
        appliedThreshold: null,
        createdAt: '2026-07-14T08:01:00.000Z',
      },
      {
        id: 'log-4640-2',
        invoiceId: 'RE-2026-04640',
        step: 'categorize',
        actor: 'system',
        result: 'K2',
        appliedThreshold: THRESHOLD_SNAPSHOT,
        appliedVersionId: null,
        createdAt: '2026-07-14T08:05:00.000Z',
      },
    ],
    latestCategory: 'K2',
    appliedThreshold: THRESHOLD_SNAPSHOT,
    isReproducible: true,
  },
};
